import { ReactNode } from "react";
import Icon, { IconName } from "components/icon";
import Typography from "components/typography";

interface DriverAccordionProps {
  title: string;
  subtitle: string;
  iconName: IconName;
  isOpen: boolean;
  onToggle: () => void;
  children?: ReactNode;
  isCompleted?: boolean;
}

const DriverAccordion = ({
  title,
  subtitle,
  iconName,
  isOpen,
  onToggle,
  children,
  isCompleted = false,
}: DriverAccordionProps) => {
  return (
    <section className="rounded-2xl bg-whiteScale-90 shadow-sm">
      <button
        type="button"
        className="w-full flex items-start justify-between px-6 py-5 text-left"
        onClick={onToggle}
      >
        <div className="flex flex-col gap-1">
          <Typography variant="heading4" as="h2" className="text-primary-700 uppercase tracking-wide text-sm">
            <span className="inline-flex items-center gap-2">
              <Icon name={iconName} size={16} />
              {title}
              {isCompleted ? <span className="h-2 w-2 rounded-full bg-success-500" /> : null}
            </span>
          </Typography>
          <Typography variant="bodySmall" tone="muted">
            {subtitle}
          </Typography>
        </div>
        <Icon name={isOpen ? "arrow-up-2" : "arrow-down-2"} size={16} />
      </button>

      {isOpen ? <div className="px-6 pb-6">{children}</div> : null}
    </section>
  );
};

export default DriverAccordion;
